"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3978],{

/***/ 53978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ getThemeComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(6337);
;// CONCATENATED MODULE: ./src/utils/commonWidgetFn.js

var isRedirectedFromWebsiteBuilder = function() {
    if (!checkRenderEnv/* IS_SERVER */.W6) {
        var ref;
        var currentUrl = window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href;
        var searchString = "/widgets/dnd";
        return currentUrl === null || currentUrl === void 0 ? void 0 : currentUrl.includes(searchString);
    } else {
        return false;
    }
};

// EXTERNAL MODULE: ./src/constants/widgets.ts
var widgets = __webpack_require__(42381);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/NewAnnouncementBar/index.tsx + 3 modules
var NewAnnouncementBar = __webpack_require__(90807);
;// CONCATENATED MODULE: ./src/utils/themeImports.js




var LaunchingSoon = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3948).then(__webpack_require__.bind(__webpack_require__, 73948));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73948)
            ];
        }
    }
});
var Header1 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2891).then(__webpack_require__.bind(__webpack_require__, 42891));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(42891)
            ];
        }
    }
});
var Header2 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7556).then(__webpack_require__.bind(__webpack_require__, 77556));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(77556)
            ];
        }
    }
});
var Header3 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7872).then(__webpack_require__.bind(__webpack_require__, 47872));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(47872)
            ];
        }
    }
});
var Header7 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 824).then(__webpack_require__.bind(__webpack_require__, 40824));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40824)
            ];
        }
    }
});
var Header8 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5025), __webpack_require__.e(1169)]).then(__webpack_require__.bind(__webpack_require__, 52264));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52264)
            ];
        }
    }
});
var Header9 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5025), __webpack_require__.e(9002)]).then(__webpack_require__.bind(__webpack_require__, 9002));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9002)
            ];
        }
    }
});
var Header10 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(8633), __webpack_require__.e(9706)]).then(__webpack_require__.bind(__webpack_require__, 29706));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29706)
            ];
        }
    }
});
var Header11 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8633), __webpack_require__.e(7101)]).then(__webpack_require__.bind(__webpack_require__, 47101));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(47101)
            ];
        }
    }
});
var Header12 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8633), __webpack_require__.e(3829)]).then(__webpack_require__.bind(__webpack_require__, 93829));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93829)
            ];
        }
    }
});
var Header14 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(8633), __webpack_require__.e(846)]).then(__webpack_require__.bind(__webpack_require__, 80846));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80846)
            ];
        }
    }
});
// Sub Header ( Hello Bar)
var SubHeader1 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9716).then(__webpack_require__.bind(__webpack_require__, 39716));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39716)
            ];
        }
    }
});
var SubHeader2 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7147).then(__webpack_require__.bind(__webpack_require__, 57147));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57147)
            ];
        }
    }
});
var SubHeader3 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6437).then(__webpack_require__.bind(__webpack_require__, 6437));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6437)
            ];
        }
    }
});
var SubHeader4 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1694).then(__webpack_require__.bind(__webpack_require__, 81694));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81694)
            ];
        }
    }
});
// Hello Bar ( This now replaces all previous subHeaders)
var SubHeader = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6485), __webpack_require__.e(7162)]).then(__webpack_require__.bind(__webpack_require__, 59351));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59351)
            ];
        }
    }
});
// Hero banner
var HeroBanner1 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(7883)]).then(__webpack_require__.bind(__webpack_require__, 47883));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(47883)
            ];
        }
    }
});
var HeroBanner2 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(9622)]).then(__webpack_require__.bind(__webpack_require__, 89622));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89622)
            ];
        }
    }
});
var HeroBanner3 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(3020)]).then(__webpack_require__.bind(__webpack_require__, 13020));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(13020)
            ];
        }
    }
});
var HeroBanner4 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(7675)]).then(__webpack_require__.bind(__webpack_require__, 47675));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(47675)
            ];
        }
    }
});
var HeroBanner5 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(9907)]).then(__webpack_require__.bind(__webpack_require__, 39907));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39907)
            ];
        }
    }
});
var HeroBanner6 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(5998)]).then(__webpack_require__.bind(__webpack_require__, 25998));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25998)
            ];
        }
    }
});
var HeroBanner7 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(8932)]).then(__webpack_require__.bind(__webpack_require__, 28932));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28932)
            ];
        }
    }
});
var HeroBanner8 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(8496)]).then(__webpack_require__.bind(__webpack_require__, 8496));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8496)
            ];
        }
    }
});
var HeroBanner9 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(6854)]).then(__webpack_require__.bind(__webpack_require__, 16854));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16854)
            ];
        }
    }
});
// Middle Body
var MiddleBody1 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6379), __webpack_require__.e(6246), __webpack_require__.e(9996), __webpack_require__.e(4087)]).then(__webpack_require__.bind(__webpack_require__, 11842));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11842)
            ];
        }
    }
});
var MiddleBody2 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6379), __webpack_require__.e(6246), __webpack_require__.e(9996), __webpack_require__.e(1150)]).then(__webpack_require__.bind(__webpack_require__, 23972));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(23972)
            ];
        }
    }
});
var MiddleBody3 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6379), __webpack_require__.e(6246), __webpack_require__.e(9996), __webpack_require__.e(189)]).then(__webpack_require__.bind(__webpack_require__, 2187));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2187)
            ];
        }
    }
});
var MiddleBody4 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6379), __webpack_require__.e(6246), __webpack_require__.e(9996), __webpack_require__.e(185)]).then(__webpack_require__.bind(__webpack_require__, 24751));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24751)
            ];
        }
    }
});
var MiddleBody5 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(6379), __webpack_require__.e(6246), __webpack_require__.e(448), __webpack_require__.e(9996), __webpack_require__.e(3257), __webpack_require__.e(7198), __webpack_require__.e(8714)]).then(__webpack_require__.bind(__webpack_require__, 48704));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(48704)
            ];
        }
    }
});
var MiddleBody6 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(6379), __webpack_require__.e(6246), __webpack_require__.e(448), __webpack_require__.e(9996), __webpack_require__.e(3257), __webpack_require__.e(945)]).then(__webpack_require__.bind(__webpack_require__, 42501));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(42501)
            ];
        }
    }
});
var PromoList1 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1675), __webpack_require__.e(2352)]).then(__webpack_require__.bind(__webpack_require__, 52352));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52352)
            ];
        }
    }
});
var PromoList2 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1675), __webpack_require__.e(4365)]).then(__webpack_require__.bind(__webpack_require__, 44365));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44365)
            ];
        }
    }
});
var PromoList3 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1675), __webpack_require__.e(9923)]).then(__webpack_require__.bind(__webpack_require__, 29923));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29923)
            ];
        }
    }
});
var PromoList4 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1675), __webpack_require__.e(2857)]).then(__webpack_require__.bind(__webpack_require__, 72857));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72857)
            ];
        }
    }
});
var PromoList5 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1675), __webpack_require__.e(602)]).then(__webpack_require__.bind(__webpack_require__, 80602));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80602)
            ];
        }
    }
});
var Footer = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(3767)]).then(__webpack_require__.bind(__webpack_require__, 13767));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(13767)
            ];
        }
    }
});
var Footer1 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(8556)]).then(__webpack_require__.bind(__webpack_require__, 18556));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18556)
            ];
        }
    }
});
var Footer2 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5025), __webpack_require__.e(350)]).then(__webpack_require__.bind(__webpack_require__, 80350));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80350)
            ];
        }
    }
});
var Footer3 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5442).then(__webpack_require__.bind(__webpack_require__, 95442));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95442)
            ];
        }
    }
});
var CLHaveSomthingInMind = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6196).then(__webpack_require__.bind(__webpack_require__, 6196));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6196)
            ];
        }
    }
});
var EmptyWidget = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4405).then(__webpack_require__.bind(__webpack_require__, 14405));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14405)
            ];
        }
    }
});
// Category Widget
var CategoryWidget1 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8793), __webpack_require__.e(7401)]).then(__webpack_require__.bind(__webpack_require__, 57401));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57401)
            ];
        }
    }
});
var CategoryWidget2 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2934), __webpack_require__.e(6544)]).then(__webpack_require__.bind(__webpack_require__, 36544));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(36544)
            ];
        }
    }
});
var CategoryWidget3 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8793), __webpack_require__.e(6490)]).then(__webpack_require__.bind(__webpack_require__, 18254));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18254)
            ];
        }
    }
});
var CategoryWidget4 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2934), __webpack_require__.e(1572)]).then(__webpack_require__.bind(__webpack_require__, 91572));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91572)
            ];
        }
    }
});
var CategoryWidget7 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8793), __webpack_require__.e(9135)]).then(__webpack_require__.bind(__webpack_require__, 69135));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69135)
            ];
        }
    }
});
var CategoryWidget8 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2934), __webpack_require__.e(6468)]).then(__webpack_require__.bind(__webpack_require__, 96468));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96468)
            ];
        }
    }
});
var CategoryWidget9 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7838).then(__webpack_require__.bind(__webpack_require__, 67838));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(67838)
            ];
        }
    }
});
var CategoryWidget10 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8793), __webpack_require__.e(2692)]).then(__webpack_require__.bind(__webpack_require__, 32692));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32692)
            ];
        }
    }
});
var CategoryWidget11 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8793), __webpack_require__.e(8060)]).then(__webpack_require__.bind(__webpack_require__, 78060));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78060)
            ];
        }
    }
});
var CategoryWidget12 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2934), __webpack_require__.e(3098)]).then(__webpack_require__.bind(__webpack_require__, 43098));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(43098)
            ];
        }
    }
});
var CategoryWidget13 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7268), __webpack_require__.e(7437)]).then(__webpack_require__.bind(__webpack_require__, 57437));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57437)
            ];
        }
    }
});
var CategoryWidget14 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9746), __webpack_require__.e(7170)]).then(__webpack_require__.bind(__webpack_require__, 7170));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7170)
            ];
        }
    }
});
var CategoryWidget15 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7268), __webpack_require__.e(7610)]).then(__webpack_require__.bind(__webpack_require__, 87610));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(87610)
            ];
        }
    }
});
var CategoryWidget16 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9746), __webpack_require__.e(2042)]).then(__webpack_require__.bind(__webpack_require__, 82042));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(82042)
            ];
        }
    }
});
var CategoryHeader1 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4483).then(__webpack_require__.bind(__webpack_require__, 54483));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(54483)
            ];
        }
    }
});
var CategoryHeader2 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4381).then(__webpack_require__.bind(__webpack_require__, 84381));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84381)
            ];
        }
    }
});
var CategoryHeader3 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7979).then(__webpack_require__.bind(__webpack_require__, 67979));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(67979)
            ];
        }
    }
});
// CategoryHeader4,
// CategoryHeader5,
var CollectionWidget1 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4546).then(__webpack_require__.bind(__webpack_require__, 24546));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24546)
            ];
        }
    }
});
var CollectionCategoryProductWidget1 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6379), __webpack_require__.e(6246), __webpack_require__.e(9996), __webpack_require__.e(1311)]).then(__webpack_require__.bind(__webpack_require__, 89391));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89391)
            ];
        }
    }
});
var DisclaimerWidget = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1026).then(__webpack_require__.bind(__webpack_require__, 91026));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91026)
            ];
        }
    }
});
var CategoryProducsDisplayWidget = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(6379), __webpack_require__.e(6246), __webpack_require__.e(437), __webpack_require__.e(9719), __webpack_require__.e(6499), __webpack_require__.e(2287), __webpack_require__.e(4505), __webpack_require__.e(2755), __webpack_require__.e(9996), __webpack_require__.e(7522)]).then(__webpack_require__.bind(__webpack_require__, 93247));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93247)
            ];
        }
    }
});
var AdvanceCatalogMiddleBody = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4434), __webpack_require__.e(6379), __webpack_require__.e(6246), __webpack_require__.e(4914), __webpack_require__.e(8154), __webpack_require__.e(9996), __webpack_require__.e(6174), __webpack_require__.e(6434)]).then(__webpack_require__.bind(__webpack_require__, 6174));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6174)
            ];
        }
    }
});
var JsonPageBuilderWidget = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6449), __webpack_require__.e(3641)]).then(__webpack_require__.bind(__webpack_require__, 13641)).then(function(mod) {
        return mod.JsonPageBuilderWidget;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(13641)
            ];
        }
    }
});
var AdditionalPage = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(531), __webpack_require__.e(9719), __webpack_require__.e(6499), __webpack_require__.e(2287), __webpack_require__.e(7858)]).then(__webpack_require__.bind(__webpack_require__, 59108));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59108)
            ];
        }
    }
});
/**                       Modern Hero Banner Themes                               */ /**  Modern Hero Banners  */ var ModernHeroBanner1 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5960).then(__webpack_require__.bind(__webpack_require__, 5960));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5960)
            ];
        }
    }
});
var ModernHeroBanner2 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6134).then(__webpack_require__.bind(__webpack_require__, 86134));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(86134)
            ];
        }
    }
});
var ModernHeroBanner3 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6982).then(__webpack_require__.bind(__webpack_require__, 36982));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(36982)
            ];
        }
    }
});
var ModernHeroBanner4 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7168).then(__webpack_require__.bind(__webpack_require__, 17168));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17168)
            ];
        }
    }
});
var ModernHeroBanner5 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8694).then(__webpack_require__.bind(__webpack_require__, 8694));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8694)
            ];
        }
    }
});
var ModernHeroBanner6 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1203).then(__webpack_require__.bind(__webpack_require__, 81203));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81203)
            ];
        }
    }
});
/**  Modern Middle Body 2-Column  */ var ModernMiddleBodyColumn1 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5558).then(__webpack_require__.bind(__webpack_require__, 25558));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25558)
            ];
        }
    }
});
var ModernMiddleBodyColumn2 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2281).then(__webpack_require__.bind(__webpack_require__, 22281));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22281)
            ];
        }
    }
});
var ModernMiddleBodyColumn3 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6288).then(__webpack_require__.bind(__webpack_require__, 86288));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(86288)
            ];
        }
    }
});
var ModernMiddleBodyColumn4 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2677).then(__webpack_require__.bind(__webpack_require__, 52677));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52677)
            ];
        }
    }
});
var ModernMiddleBodyColumn5 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7489).then(__webpack_require__.bind(__webpack_require__, 97489));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97489)
            ];
        }
    }
});
var ModernMiddleBodyColumn6 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3275).then(__webpack_require__.bind(__webpack_require__, 63275));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63275)
            ];
        }
    }
});
/**  Modern Middle Body Gallery  */ var ModernMiddleBodyGallery1 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8460).then(__webpack_require__.bind(__webpack_require__, 71892));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71892)
            ];
        }
    }
});
var ModernMiddleBodyGallery2 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8955).then(__webpack_require__.bind(__webpack_require__, 88955));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88955)
            ];
        }
    }
});
var ModernMiddleBodyGallery3 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9990).then(__webpack_require__.bind(__webpack_require__, 19990));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19990)
            ];
        }
    }
});
var ModernMiddleBodyGallery4 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5900).then(__webpack_require__.bind(__webpack_require__, 25900));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25900)
            ];
        }
    }
});
var ModernMiddleBodyGallery5 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4096).then(__webpack_require__.bind(__webpack_require__, 74096));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(74096)
            ];
        }
    }
});
var ModernMiddleBodyGallery6 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 634).then(__webpack_require__.bind(__webpack_require__, 80634));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80634)
            ];
        }
    }
});
var ModernMiddleBodyGallery7 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2958).then(__webpack_require__.bind(__webpack_require__, 32958));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32958)
            ];
        }
    }
});
var ModernMiddleBodyGallery8 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9673).then(__webpack_require__.bind(__webpack_require__, 59673));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59673)
            ];
        }
    }
});
var ModernHeader1 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6536).then(__webpack_require__.bind(__webpack_require__, 76536));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76536)
            ];
        }
    }
});
/**  Modern Middle Body Tabs     */ var ModernMiddleBodyTab1 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2988).then(__webpack_require__.bind(__webpack_require__, 2988));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2988)
            ];
        }
    }
});
var ModernMiddleBodyTab2 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6288), __webpack_require__.e(9658)]).then(__webpack_require__.bind(__webpack_require__, 69658));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69658)
            ];
        }
    }
});
var ModernMiddleBodyTab3 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7657).then(__webpack_require__.bind(__webpack_require__, 37657));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37657)
            ];
        }
    }
});
var ModernFooter1 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6035), __webpack_require__.e(5790)]).then(__webpack_require__.bind(__webpack_require__, 66035));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(66035)
            ];
        }
    }
});
var ModernFooter2 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3411).then(__webpack_require__.bind(__webpack_require__, 3411));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3411)
            ];
        }
    }
});
var ModernFooter3 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3411), __webpack_require__.e(6035), __webpack_require__.e(9928)]).then(__webpack_require__.bind(__webpack_require__, 99928));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99928)
            ];
        }
    }
});
var ModernFooter4 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3411), __webpack_require__.e(6035), __webpack_require__.e(2426)]).then(__webpack_require__.bind(__webpack_require__, 12426));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12426)
            ];
        }
    }
});
var ModernMiddleBodyMaps = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6238).then(__webpack_require__.bind(__webpack_require__, 16238));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16238)
            ];
        }
    }
});
var NewHeaderComponent = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 50479)).then(function(mod) {
        return mod.NewHeaderWrapper;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(50479)
            ];
        }
    }
});
var NewHeroBanner = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6911), __webpack_require__.e(1509), __webpack_require__.e(5675), __webpack_require__.e(373), __webpack_require__.e(666), __webpack_require__.e(5063)]).then(__webpack_require__.bind(__webpack_require__, 99170)).then(function(mod) {
        return mod.CarouselWidget;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99170)
            ];
        }
    }
});
var RichTextWithImageWidget = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6911), __webpack_require__.e(1509), __webpack_require__.e(373), __webpack_require__.e(666), __webpack_require__.e(1849)]).then(__webpack_require__.bind(__webpack_require__, 99849));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99849)
            ];
        }
    }
});
var RichTextWidget = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6911), __webpack_require__.e(1509), __webpack_require__.e(373), __webpack_require__.e(666), __webpack_require__.e(3749)]).then(__webpack_require__.bind(__webpack_require__, 24681));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24681)
            ];
        }
    }
});
var NewFooterComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6911), __webpack_require__.e(1509), __webpack_require__.e(373), __webpack_require__.e(666), __webpack_require__.e(9455), __webpack_require__.e(5275)]).then(__webpack_require__.bind(__webpack_require__, 19455));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19455)
            ];
        }
    }
});
var ListPresentation = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9719), __webpack_require__.e(6499), __webpack_require__.e(2287), __webpack_require__.e(3383)]).then(__webpack_require__.bind(__webpack_require__, 76551));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76551)
            ];
        }
    }
});



var WhatsappFloatingIcon = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 906).then(__webpack_require__.bind(__webpack_require__, 30906));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(30906)
            ];
        }
    }
});
function isWrongHeaderConfigPresent(type, name) {
    if ((type === null || type === void 0 ? void 0 : type.includes("CollectionHeaderDropdownWidget")) || (name === null || name === void 0 ? void 0 : name.includes("CollectionHeaderDropdownWidget"))) {
        return true;
    }
    return false;
}
var getThemeComponent = function(type, name, props) {
    // This check is for stores with wrong config set due to an earlier bug, this sets the most used header type
    if (isWrongHeaderConfigPresent(type, name)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header12, (0,_object_spread/* default */.Z)({}, props));
    }
    switch(type){
        case "Header":
            if (name === "Header1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header1, (0,_object_spread/* default */.Z)({
                showStoreNameOnMobile: true
            }, props));
            if (name === "Header2") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header2, (0,_object_spread/* default */.Z)({
                showStoreNameOnMobile: true
            }, props));
            if (name === "Header3") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header3, (0,_object_spread/* default */.Z)({
                showStoreNameOnMobile: true
            }, props));
            if (name === "Header4") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header1, (0,_object_spread/* default */.Z)({
                showStoreNameOnMobile: false
            }, props));
            if (name === "Header5") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header2, (0,_object_spread/* default */.Z)({
                showStoreNameOnMobile: false
            }, props));
            if (name === "Header6") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header3, (0,_object_spread/* default */.Z)({
                showStoreNameOnMobile: false
            }, props));
            if (name === "Header7") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header7, (0,_object_spread/* default */.Z)({}, props));
            if (name === "Header8") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header8, (0,_object_spread/* default */.Z)({}, props));
            if (name === "Header9") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header9, (0,_object_spread/* default */.Z)({}, props)); // this is for non premium users in desktop web showcase
            if (name === "Header10") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header10, (0,_object_spread/* default */.Z)({}, props));
            if (name === "Header11") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header11, (0,_object_spread/* default */.Z)({}, props));
            if (name === "Header12") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header12, (0,_object_spread/* default */.Z)({}, props));
            if (name === "Header13") // Custom requirement for a merchant
            // show Categories props is used for either remove or change pages name in navigation header
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header8, (0,_object_spread/* default */.Z)({
                showCategories: true
            }, props));
            if (name === "Header14") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header14, (0,_object_spread/* default */.Z)({}, props));
            if (name === "NewHeader") return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewHeaderComponent, (0,_object_spread/* default */.Z)({}, props));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "HeroBanner":
            if (name === "HeroBanner1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBanner1, (0,_object_spread/* default */.Z)({}, props));
            if (name === "HeroBanner2") return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBanner2, (0,_object_spread/* default */.Z)({}, props));
            if (name === "HeroBanner3") return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBanner3, (0,_object_spread/* default */.Z)({}, props));
            if (name === "HeroBanner4") return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBanner4, (0,_object_spread/* default */.Z)({}, props));
            if (name === "HeroBanner5") return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBanner5, (0,_object_spread/* default */.Z)({}, props));
            if (name === "HeroBanner6") return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBanner6, (0,_object_spread/* default */.Z)({}, props));
            if (name === "HeroBanner7") return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBanner7, (0,_object_spread/* default */.Z)({}, props));
            if (name === "HeroBanner8") return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBanner8, (0,_object_spread/* default */.Z)({}, props));
            if (name === "HeroBanner9") return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBanner9, (0,_object_spread/* default */.Z)({}, props));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "Carousel":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewHeroBanner, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                forNewCarousel: false
            }));
        case widgets/* ADMIN_WIDGETS.HERO_BANNER.type */.Pe.HERO_BANNER.type:
        case widgets/* ADMIN_WIDGETS.SLIDESHOW.type */.Pe.SLIDESHOW.type:
            return ((props === null || props === void 0 ? void 0 : props.isVisible) || (props === null || props === void 0 ? void 0 : props.isVisible) === "undefined") && /*#__PURE__*/ (0,jsx_runtime.jsx)(NewHeroBanner, (0,_object_spread/* default */.Z)({}, props));
        case "SubHeader":
            if (name === "SubHeader1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubHeader1, (0,_object_spread/* default */.Z)({}, props));
            if (name === "SubHeader2") return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubHeader2, (0,_object_spread/* default */.Z)({}, props));
            if (name === "SubHeader3") return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubHeader3, (0,_object_spread/* default */.Z)({}, props));
            if (name === "SubHeader4") return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubHeader4, (0,_object_spread/* default */.Z)({}, props));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case widgets/* ADMIN_WIDGETS.RICH_TEXT_WITH_IMAGE.type */.Pe.RICH_TEXT_WITH_IMAGE.type:
            return (props === null || props === void 0 ? void 0 : props.isVisible) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextWithImageWidget, (0,_object_spread/* default */.Z)({}, props)) : null;
        case widgets/* ADMIN_WIDGETS.RICH_TEXT.type */.Pe.RICH_TEXT.type:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextWidget, (0,_object_spread/* default */.Z)({}, props));
        case widgets/* ADMIN_WIDGETS.WHATSAPP_FLOATING_ICON.type */.Pe.WHATSAPP_FLOATING_ICON.type:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatsappFloatingIcon, (0,_object_spread/* default */.Z)({}, props));
        case "HelloBar":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubHeader, (0,_object_spread/* default */.Z)({}, props));
        case widgets/* ADMIN_WIDGETS.CATEGORY.name */.Pe.CATEGORY.name:
        case widgets/* ADMIN_WIDGETS.COLLECTIONS.name */.Pe.COLLECTIONS.name:
        case widgets/* ADMIN_WIDGETS.INSTAGRAM_REELS.name */.Pe.INSTAGRAM_REELS.name:
        case widgets/* ADMIN_WIDGETS.FEATURED_COLLECTIONS.name */.Pe.FEATURED_COLLECTIONS.name:
        case widgets/* ADMIN_WIDGETS.FEATURED_CATEGORIES.name */.Pe.FEATURED_CATEGORIES.name:
        case widgets/* ADMIN_WIDGETS.FEATURED_TAGS.name */.Pe.FEATURED_TAGS.name:
        case widgets/* ADMIN_WIDGETS.MULTI_COLUMN_WITH_ICON.name */.Pe.MULTI_COLUMN_WITH_ICON.name:
        case widgets/* ADMIN_WIDGETS.MULTI_COLUMN_WITH_IMAGE.name */.Pe.MULTI_COLUMN_WITH_IMAGE.name:
        case widgets/* ADMIN_WIDGETS.LOGO_SLIDER.name */.Pe.LOGO_SLIDER.name:
        case widgets/* ADMIN_WIDGETS.FEATURED_REELS.name */.Pe.FEATURED_REELS.name:
        case widgets/* ADMIN_WIDGETS.BLOG_WIDGET.name */.Pe.BLOG_WIDGET.name:
        case widgets/* ADMIN_WIDGETS.TESTIMONIALS.name */.Pe.TESTIMONIALS.name:
        case widgets/* ADMIN_WIDGETS.GALLERY.name */.Pe.GALLERY.name:
        case widgets/* ADMIN_WIDGETS.PRODUCT_TESTIMONIALS.name */.Pe.PRODUCT_TESTIMONIALS.name:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListPresentation, (0,_object_spread/* default */.Z)({}, props));
        case widgets/* ADMIN_WIDGETS.NEW_ANNOUNCEMENT_BAR.name */.Pe.NEW_ANNOUNCEMENT_BAR.name:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewAnnouncementBar/* NewAnnouncementBar */.g, (0,_object_spread/* default */.Z)({}, props));
        case "MiddleBody":
            if (name === "MiddleBody1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBody1, (0,_object_spread/* default */.Z)({}, props));
            if (name === "MiddleBody2") return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBody2, (0,_object_spread/* default */.Z)({}, props));
            if (name === "MiddleBody3") return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBody3, (0,_object_spread/* default */.Z)({}, props));
            if (name === "MiddleBody4") return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBody4, (0,_object_spread/* default */.Z)({}, props));
            if (name === "MiddleBody5") return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBody5, (0,_object_spread/* default */.Z)({}, props));
            /* This check for Middlebody6 is used as a hack for MiddleBody6 freeze issue in Website Builder */ if (name === "MiddleBody6" && isRedirectedFromWebsiteBuilder()) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBody6, (0,_object_spread/* default */.Z)({
                    displayMiddleBodyInWebsiteBuilder: true
                }, props));
            } else {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBody6, (0,_object_spread/* default */.Z)({}, props));
            }
        case "SortingAndFilterWidget":
            if (name === "SortingAndFilterWidget1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvanceCatalogMiddleBody, (0,_object_spread/* default */.Z)({}, props));
            if (name === "SortingAndFilterWidget2") return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBody5, (0,_object_spread/* default */.Z)({
                sortAndFiltersEnabled: true
            }, props));
            if (name === "SortingAndFilterWidget3") return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBody6, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                sortAndFiltersEnabled: true
            }));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "Footer":
            if (name === "Footer") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, (0,_object_spread/* default */.Z)({}, props));
            if (name === "Footer1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer1, (0,_object_spread/* default */.Z)({}, props));
            if (name === "Footer2") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer2, (0,_object_spread/* default */.Z)({}, props));
            if (name === "Footer3") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer3, (0,_object_spread/* default */.Z)({}, props));
            if (name === "Footer4") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer3, (0,_object_spread/* default */.Z)({
                includeCollectionSet: true
            }, props));
            if (name === widgets/* ADMIN_WIDGETS.FOOTER.type */.Pe.FOOTER.type) return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewFooterComponent, (0,_object_spread/* default */.Z)({}, props));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "Offers":
            if (name === "PromoList1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoList1, (0,_object_spread/* default */.Z)({}, props));
            if (name === "PromoList2") return /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoList2, (0,_object_spread/* default */.Z)({}, props));
            if (name === "PromoList3") return /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoList3, (0,_object_spread/* default */.Z)({}, props));
            if (name === "PromoList4") return /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoList4, (0,_object_spread/* default */.Z)({}, props));
            if (name === "PromoList5") return /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoList5, (0,_object_spread/* default */.Z)({}, props));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "CreateList":
            if (name === "CreateList") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CLHaveSomthingInMind, (0,_object_spread/* default */.Z)({}, props));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "StaticWidget":
            if (name === "StaticWidget") return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyWidget, (0,_object_spread/* default */.Z)({}, props));
            if (name === "DisclaimerStaticWidget") return /*#__PURE__*/ (0,jsx_runtime.jsx)(DisclaimerWidget, (0,_object_spread/* default */.Z)({}, props));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "CategoryWidget":
            if (name === "CategoryWidget1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget1, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryWidget2") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget2, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryWidget3") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget3, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryWidget4") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget4, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryWidget5") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget1, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryWidget6") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget2, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryWidget7") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget7, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryWidget8") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget8, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryWidget9") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget9, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryWidget10") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget10, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryWidget11") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget11, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryWidget12") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget12, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryWidget13") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget13, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryWidget14") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget14, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                headerFixedToTop: true
            }));
            if (name === "CategoryWidget15") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget15, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryWidget16") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget16, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                headerFixedToTop: true
            }));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "CategoryProductWidget":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryProducsDisplayWidget, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                widgetName: name
            }));
        case "CategoryHeaderWidget":
            if (name === "CategoryHeader1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryHeader1, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryHeader2") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryHeader2, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryHeader3") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryHeader3, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryHeader4") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryHeader3, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryHeader5") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryHeader3, (0,_object_spread/* default */.Z)({}, props));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "AdditionalPageWidget":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AdditionalPage, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                source: "home"
            }));
        case "CollectionWidget":
            if (name === "CollectionWidget1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionWidget1, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                cardType: 1
            }));
            if (name === "CollectionWidget2") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionWidget1, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                cardType: 2
            }));
            if (name === "CollectionWidget3") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionWidget1, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                cardType: 1
            }));
        case "CollectionCategoryProductWidget":
            if (name === "CollectionCategoryProductWidget1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionCategoryProductWidget1, (0,_object_spread/* default */.Z)({}, props));
        case "JsonPageWidget":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(JsonPageBuilderWidget, (0,_object_spread/* default */.Z)({}, props));
        case "LaunchingSoon":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LaunchingSoon, (0,_object_spread/* default */.Z)({}, props));
        /* Modern Theme Components - Brand Websites */ case "ModernHeroBanner":
            if (name === "ModernHeroBanner1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernHeroBanner1, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernHeroBanner2") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernHeroBanner2, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernHeroBanner3") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernHeroBanner3, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernHeroBanner4") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernHeroBanner4, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernHeroBanner5") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernHeroBanner5, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernHeroBanner6") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernHeroBanner6, (0,_object_spread/* default */.Z)({}, props));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "ModernMiddleBodyColumn":
            if (name === "ModernMiddleBodyColumn1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyColumn1, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernMiddleBodyColumn2") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyColumn2, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernMiddleBodyColumn3") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyColumn3, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernMiddleBodyColumn4") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyColumn4, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernMiddleBodyColumn5") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyColumn5, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernMiddleBodyColumn6") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyColumn6, (0,_object_spread/* default */.Z)({}, props));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "ModernMiddleBodyGallery":
            if (name === "ModernMiddleBodyGallery1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyGallery1, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernMiddleBodyGallery2") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyGallery2, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernMiddleBodyGallery3") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyGallery3, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernMiddleBodyGallery4") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyGallery4, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernMiddleBodyGallery5") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyGallery5, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernMiddleBodyGallery6") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyGallery6, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernMiddleBodyGallery7") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyGallery7, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernMiddleBodyGallery8") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyGallery8, (0,_object_spread/* default */.Z)({}, props));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "ModernMiddleBodyTabs":
            if (name === "ModernMiddleBodyTab1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyTab1, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernMiddleBodyTab2") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyTab2, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernMiddleBodyTab3") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyTab3, (0,_object_spread/* default */.Z)({}, props));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "ModernHeader":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernHeader1, (0,_object_spread/* default */.Z)({}, props));
        case "ModernFooter":
            if (name === "ModernFooter1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernFooter1, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernFooter2") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernFooter2, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernFooter3") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernFooter3, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernFooter4") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernFooter4, (0,_object_spread/* default */.Z)({}, props));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "ModernMiddleBodyMaps":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyMaps, (0,_object_spread/* default */.Z)({}, props));
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
};


/***/ })

}]);